export default __webpack_public_path__ + "static/media/Cane2Sugar_04.5b9a4577.png";